export const buckets = {
  questionnaires: "questionnaires",
  questions: "questions",
  certificateAssets: "certificateAssets",
  signingCredentials: "signingCredentials",
  certificates: "certificates",
} as const;
